/**
 * Constantes de rutas del backend `sisma-nest`.
 * Mantener sincronizado con los controllers de NestJS.
 */
export const ENDPOINTS = {
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    me: '/auth/me',
    changePassword: '/auth/change-password',
  },
  users: '/users',
  municipalities: '/municipalities',
  branches: '/branches',
  specialties: '/specialties',
  teams: '/teams',
  standards: '/standards',
  agentTypes: '/agent-types',
  doctors: '/doctors',
  agents: '/agents',
  affiliates: '/affiliates',
  contracts: '/contracts',
  appointments: '/appointments',
  tariffs: '/tariffs',
  installments: '/installments',
  invoices: '/invoices',
  collections: '/collections',
  receipts: '/receipts',
  provisionals: '/provisionals',
  checks: '/checks',
  cards: '/cards',
  bonifications: '/bonifications',
  stationery: '/stationery',
  discounts: '/discounts',
  collectionForms: '/collection-forms',
  advertisingMaterials: '/advertising-materials',
  inventory: {
    itemTypes: '/inventory/item-types',
    movements: '/inventory/movements',
    balances: '/inventory/balances',
  },
  suppliers: '/suppliers',
  purchases: '/purchases',
  warehouse: '/warehouse',
  fixedAssets: '/fixed-assets',
  reports: '/reports',
  siigo: '/siigo-interfaces',
} as const;
